import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Footer.css";
import logo from "../assets/logo.png";
import api from "../api";

const Footer = () => {
  const [showChat, setShowChat] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  const validatePhone = (phone) =>
    /^(\+?\d{7,15})$/.test(phone.replace(/[\s\-()]/g, ""));

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    if (errors[name]) setErrors({ ...errors, [name]: "" });
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name.trim())    newErrors.name    = "Name is required";
    if (!formData.email.trim())   newErrors.email   = "Email is required";
    else if (!validateEmail(formData.email)) newErrors.email = "Please enter a valid email";
    if (!formData.phone.trim())   newErrors.phone   = "Phone number is required";
    else if (!validatePhone(formData.phone))
      newErrors.phone = "Please enter a valid phone (e.g. +61 400 000 000)";
    if (!formData.message.trim()) newErrors.message = "Message is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    setLoading(true);
    try {
      await api.post("members/welfare-message/", formData);
      alert("Your message has been sent to the welfare team.");
      setFormData({ name: "", email: "", phone: "", message: "" });
      setErrors({});
      setShowChat(false);
    } catch (error) {
      console.error(error);
      alert("Unable to send message. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <footer className="footer">
        <div className="footer-container">
          <div className="footer-logo">
            <img src={logo} alt="Marakwet Community Logo" />
            <h3>Marakwet Community in Australia Inc.</h3>
            <p className="footer-motto">We left Home to Change Home</p>
            <p className="footer-abn">Incorporated Association Victoria, Australia</p>
          </div>

          <div className="footer-links">
            <h4>Quick Links</h4>
            <ul>
              <li><a href="/">Home</a></li>
              <li><a href="/about">About Us</a></li>
              <li><a href="/events">Events</a></li>
              <li><a href="/membership">Membership</a></li>
              <li><a href="/blog">Blog</a></li>
              <li><a href="/sponsorship">Sponsorship</a></li>
              <li><a href="/opportunities">Opportunities</a></li>
            </ul>
          </div>

          <div className="footer-contact">
            <h4>Contact Us</h4>
            <p>Email: info@marakwetcommunityinaustralia.org</p>
            <p>Phone: +61411494404</p>
            <p>Location: Victoria, Australia</p>

            <h4 style={{ marginTop: "1rem" }}>Legal</h4>
            <ul className="footer-legal-links">
              {/* These links are required by NAB */}
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
              <li><Link to="/refund-policy">Refund &amp; Cancellation Policy</Link></li>
            </ul>

            <p className="footer-payment-note">
              🔒 Payments secured by Stripe.<br />
              All prices in Australian Dollars (AUD).
            </p>
          </div>
        </div>

        <div className="footer-bottom">
          <p>
            © {new Date().getFullYear()} Marakwet Community in Australia Inc. All Rights Reserved.
          </p>
        </div>
      </footer>

      {/* Floating Chat Icon */}
      <button className="chat-icon" onClick={() => setShowChat(!showChat)}>
        💬
      </button>

      {/* Chat Popup */}
      {showChat && (
        <div className="chat-popup">
          <h3>Message Welfare Team</h3>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <input
                type="text"
                name="name"
                placeholder="Your Full Name"
                value={formData.name}
                onChange={handleChange}
                className={errors.name ? "error" : ""}
              />
              {errors.name && <span className="error-message">{errors.name}</span>}
            </div>
            <div className="form-group">
              <input
                type="email"
                name="email"
                placeholder="Your Email"
                value={formData.email}
                onChange={handleChange}
                className={errors.email ? "error" : ""}
              />
              {errors.email && <span className="error-message">{errors.email}</span>}
            </div>
            <div className="form-group">
              <input
                type="tel"
                name="phone"
                placeholder="Phone (e.g. +61 400 000 000)"
                value={formData.phone}
                onChange={handleChange}
                className={errors.phone ? "error" : ""}
              />
              {errors.phone && <span className="error-message">{errors.phone}</span>}
            </div>
            <div className="form-group">
              <textarea
                name="message"
                placeholder="Type your message here..."
                value={formData.message}
                onChange={handleChange}
                className={errors.message ? "error" : ""}
              />
              {errors.message && <span className="error-message">{errors.message}</span>}
            </div>
            <button type="submit" className="send-btn" disabled={loading}>
              {loading ? "Sending..." : "Send Message"}
            </button>
          </form>
          <button className="close-btn" onClick={() => setShowChat(false)}>✖</button>
        </div>
      )}
    </>
  );
};

export default Footer;
